import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faBars, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import React, { useState, useEffect, useRef } from 'react';

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navRef = useRef(null);

    const toggleMobileMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLinkClick = (e, targetId) => {
        e.preventDefault();
        const target = document.querySelector(targetId);
        if (target) {
            window.scrollTo({
                top: target.offsetTop - 70,
                behavior: 'smooth'
            });
            setIsMenuOpen(false);
        }
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'Escape' && isMenuOpen) {
                setIsMenuOpen(false);
            }
        };
        const handleClickOutside = (e) => {
            if (navRef.current && !navRef.current.contains(e.target)) {
                setIsMenuOpen(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isMenuOpen]);

    return (
        <header>
            <div className="container nav-container" ref={navRef}>
                <button
                    className="mobile-menu-btn"
                    onClick={toggleMobileMenu}
                    aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'}
                    aria-expanded={isMenuOpen}
                    aria-controls="nav-list"
                >
                    <FontAwesomeIcon icon={faBars} />
                </button>
                <ul id="nav-list" className={`nav-list ${isMenuOpen ? 'active' : ''}`}>
                    <li className="nav-item">
                        <a
                            href="https://www.linkedin.com/in/tianrui-zhu-a443bb262/"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link"
                            aria-label="LinkedIn profile (opens in new tab)"
                        >
                            <FontAwesomeIcon icon={faLinkedinIn} aria-hidden="true" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href="https://github.com/CodeCary80"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link"
                            aria-label="GitHub profile (opens in new tab)"
                        >
                            <FontAwesomeIcon icon={faGithub} aria-hidden="true" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            href="#contact"
                            onClick={(e) => handleLinkClick(e, '#contact')}
                            className="nav-link"
                            aria-label="Jump to contact section"
                        >
                            <FontAwesomeIcon icon={faEnvelope} aria-hidden="true" />
                        </a>
                    </li>
                </ul>
            </div>
        </header>
    );
};

export default Header;